import printComponent from './bagouts.component';

let printModule = angular.module('branchMgmtBagoutPrint', [
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/branchManagement.bagouts');

        $stateProvider
            .state('branchMgmtBagoutPrint', {
                url: '/print-bagout',
                component: 'branchMgmtBagoutPrint',
                data: {
                    requireLogin: true,
                    requireACL: 'branch_mgmt_bagouts.all'
                },
            })
    })

    .component('branchMgmtBagoutPrint', printComponent)

    .name;

export default printModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bagouts/print/index.js